import { render, staticRenderFns } from "./singleFood.vue?vue&type=template&id=09424910&scoped=true&"
import script from "./singleFood.vue?vue&type=script&lang=js&"
export * from "./singleFood.vue?vue&type=script&lang=js&"
import style0 from "./singleFood.vue?vue&type=style&index=0&id=09424910&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09424910",
  null
  
)

export default component.exports